// extracted by mini-css-extract-plugin
module.exports = {"root":"root--s6VQn"};